import { datadogLogs } from "@datadog/browser-logs";

const getCorrectLogger = () =>
  import.meta.env.VITE_DATADOG_CLIENT_TOKEN ? datadogLogs.logger : console;

type LoggerContext = {
  team?: string;
  tag?: string;
} & Record<string, unknown>;

const defaultContext: LoggerContext = {
  team: "uncategorized",
  tag: "uncategorized",
};

export type LoggerArgs = [message: string, context?: LoggerContext];

const createContext = (context: LoggerContext = {}) => ({
  ...defaultContext,
  ...context,
});

// Really simple logger wrapper that uses either datadog logger or console
export const logger = {
  error: (...[message, context]: LoggerArgs) => {
    getCorrectLogger().error(message, createContext(context));
  },
  log: (...[message, context]: LoggerArgs) => {
    getCorrectLogger().log(message, createContext(context));
  },
  warn: (...[message, context]: LoggerArgs) => {
    getCorrectLogger().warn(message, createContext(context));
  },
};
